module.exports = __webpack_public_path__ + "img/data.92cdf26d.svg";